import { ActionIcon, Button, Menu, Tooltip } from "@mantine/core";
import { IconChevronDown, IconPlus } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import CreateFieldAny from "../../components/create-field/CreateFieldAny";
import CreateFieldOptions from "../../components/create-field/CreateFieldOptions";

const ColumnAdder = ({ handleColumnCreated }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Menu keepMounted zIndex={1500} position="bottom">
      <Menu.Target>
        <Tooltip label={lang.datafields.create.button_tooltip} >
          <ActionIcon
            variant="subtle"
            ml={-16}
            className="test"
            h={36}
            style={{
              borderColor: "var(--mantine-color-primary-0)",
              borderLeft: 0,
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              background: "#fff",
            }}
          >
            <IconPlus size={18} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <CreateFieldAny onFinish={handleColumnCreated} />
        <CreateFieldOptions onFinish={handleColumnCreated} />
      </Menu.Dropdown>
    </Menu>
  );
};

export default ColumnAdder;
